export default __webpack_public_path__ + "static/media/servicepower.4490e424.png";